import { API_HOST, axiosInstance, axiosRequestWithAuth } from "../constants/server.constant";
import { toQuery } from "../utility/utility";

const fetchAlarmDetails = async (userId, alarmConfigId) => {
    return await axiosInstance.get(API_HOST + "/" + userId + "/alarm/" + alarmConfigId, axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return Promise.reject(error);
    });
};

const fetchAlarms = async (userId) => {
    return await axiosInstance.get(API_HOST + "/" + userId + "/alarm", axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return Promise.reject(error);
    });
};

const fetchAlarmsByType = async (userId, type) => {
    return await axiosInstance.get(API_HOST + "/" + userId + "/alarm/" + type, axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return Promise.reject(error);
    });
};

const createAlarm = async (userId, alarmConfig) => {
    return await axiosInstance.post(API_HOST + "/" + userId + "/alarm", alarmConfig, axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return Promise.reject(error);
    });
};

const updateAlarm = async (userId, alarmConfig) => {
    return await axiosInstance.patch(API_HOST + "/" + userId + "/alarm", alarmConfig, axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return Promise.reject(error);
    });
};

const deleteAlarm = async (userId, params) => {
    return await axiosInstance.delete(API_HOST + "/" + userId + "/alarm?" + toQuery(params), axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return Promise.reject(error);
    });
};

export const AlarmService = {
    fetchAlarmDetails,
    fetchAlarms,
    fetchAlarmsByType,
    createAlarm,
    updateAlarm,
    deleteAlarm,
};

